import * as React from 'react';

/**
 * Third Party Libs
 */
import moment from 'moment';
import 'moment/locale/es';
moment.locale('es'); // Set Moment.js to use Spanish locale

/**
 * Utilities
 */
import { getStoredReportPayload, deleteStoredReportPayload, generateKey } from '../../utils/reports';

/**
 * MUI Components
 */
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { IconButton, Divider } from '@mui/material';

/**
 * MUI Icons
 */
import DeleteIcon from '@mui/icons-material/Delete';
import PreviewIcon from '@mui/icons-material/Preview';
import SyncProblemIcon from '@mui/icons-material/SyncProblem';

/**
 * Components
 */
import ConfirmationDialog from '../Dialogs/ConfirmationDialog';

/**
 * Hooks
 */
import { useNavigate } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Displays a list of local stored reports
 * @param {object} props reports: List of local/offline reports
 * @returns the component
 */
export default function ListLocalReports({ keys }) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [reports, setReports] = useState([]);
    const dialogRef = useRef();

    const handleView = (index) => {
        const report = reports[index];
        const key = generateKey(report.payload);
        console.log('Loading local work report with key', key);
        navigate(`/work-report/edit/local/${key}`);
    };

    const handleDelete = (index) => {
        dialogRef.current.openDialog({
            title: t('Confirm Action'),
            text: t('Delete report?'),
            onConfirm: () => {
                if (reports[index]) {
                    // Remove from view and local storage
                    setReports(prevReports => prevReports.filter((_, i) => i !== index));
                    deleteStoredReportPayload(generateKey(reports[index].payload));
                } else {
                    console.error('Invalid index', index);
                }
            },
        });
    };

    useEffect(() => {
        const reports = keys.map(key => getStoredReportPayload(key));
        setReports(reports);
    }, [keys]);

    const ListRow = ({ item, index }) => {

        const work = item.context?.work || {};
        const planning = item.context?.planning || {};
        const payload = item.payload;

        return (
            <ListItem
                secondaryAction={
                    <>
                        <IconButton
                            aria-label="delete"
                            onClick={() => { handleDelete(index) }}>
                            <DeleteIcon />
                        </IconButton>
                        <IconButton
                            aria-label="view"
                            onClick={() => { handleView(index) }}>
                            <PreviewIcon />
                        </IconButton>
                    </>
                }>
                <div style={{ marginRight: 10 }}>
                    <SyncProblemIcon color='warning' />
                </div>
                <ListItemText
                    primary={work?.name || item.hash}
                    secondary={moment(item.date).fromNow()} />
            </ListItem>
        );
    };

    return (
        <>
            <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
                {reports.map((item, index) => (
                    <>
                        <ListRow item={item} index={index} />
                        <Divider sx={{ marginLeft: '50px' }} variant="inset" component="li" />
                    </>
                ))}
            </List>

            {/* Reusable ConfirmationDialog */}
            <ConfirmationDialog ref={dialogRef} />
        </>
    );
}